import GradeLessonPage from '../components/GradeLessonPage';
import { grade8Topics } from './data';

export default function Grade8Page() {
  return (
    <GradeLessonPage
      gradeData={grade8Topics}
      prevGradeLink="/grade/7"
      prevGradeLabel="Grade 7"
      nextGradeLink="/algebra1"
      nextGradeLabel="Algebra 1"
    />
  );
}
